<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'REMINDERS.REMINDERS_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <!--      <button type="button" class="btn btn-secondary" aria-label="Add" (click)="export()">-->
      <!--        {{ 'LOCALES.LOCALES_LIST.EXPORT' | translate }}-->
      <!--      </button>-->

      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="remindersResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Reminders', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'REMINDERS.REMINDERS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'REMINDERS.REMINDERS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="user.fake_first_name"
      title="{{ 'REMINDERS.REMINDERS_LIST.USER_NAME' | translate }}"
      filter="text"
      [width]="250"
      [hidden]="isHiddenColumn('user.fake_first_name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select [filter]="filter"></app-kendo-user-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.user?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="reminderable_type"
      title="{{ 'REMINDERS.REMINDERS_LIST.TYPE' | translate }}"
      [hidden]="isHiddenColumn('reminderable_type')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.cleanReminderableType }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="reminderable.about"
      title="{{ 'REMINDERS.REMINDERS_LIST.ABOUT' | translate }}"
      [hidden]="isHiddenColumn('reminderable.about')"
      [filterable]="false"
      [sortable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.about }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="reminderable_id"
      title="{{ 'REMINDERS.REMINDERS_LIST.REMINDABLE_ID' | translate }}"
      filter="numeric"
      format="0"
      [width]="150"
      [hidden]="isHiddenColumn('reminderable_id')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.reminderable_id }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="note"
      title="{{ 'REMINDERS.REMINDERS_LIST.NOTE' | translate }}"
      [filterable]="false"
      [hidden]="isHiddenColumn('note')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.note" [ngbTooltip]="dataItem.note" container="body">
          {{ dataItem.note.length > 55 ? (dataItem.note | slice : 0 : 55) + '...' : dataItem.note }}
        </span>
        <span *ngIf="!dataItem.note">—</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="remind_at"
      title="{{ 'REMINDERS.REMINDERS_LIST.REMINDER_DATE' | translate }}"
      filter="date"
      [hidden]="isHiddenColumn('reminder_date')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.remind_at | date : env.pipeDateTimeFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'REMINDERS.REMINDERS_LIST.CREATED_AT' | translate }}"
      filter="date"
      [hidden]="isHiddenColumn('created_at', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="reminded"
      title="{{ 'REMINDERS.REMINDERS_LIST.REMINDED' | translate }}"
      [filterable]="false"
      [width]="100"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('note')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.reminded"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="completed"
      title="{{ 'REMINDERS.REMINDERS_LIST.COMPLETED' | translate }}"
      filter="boolean"
      [width]="100"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('completed')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.completed"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'REMINDERS.REMINDERS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-preview-button [link]="['/reminders/view']" [params]="{ id: dataItem.id }"></app-preview-button>

        <app-edit-button (click)="edit(dataItem)"></app-edit-button>

        <app-reminder-view-button [reminder]="dataItem"></app-reminder-view-button>

        <app-delete-button [swal]="{}" (confirm)="delete(dataItem)"></app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
